<template>
  <div
    id="simon-game"
    class="simon-game"
    :height="gameWidth"
    @resize="setGameSize"
  >
    <div class="grid">
      <div class="row">
        <div class="col text-right">
          <simon-button
            :id="1"
            :activate="isActive(1)"
            :beep-volume="volume"
            color="red"
            @buttonActivated="activate"
            @buttonDeactivated="deactivate"
            :audio-frequency="210"/>
        </div>
        <div class="col">
          <simon-button
            :id="2"
            :activate="isActive(2)"
            :beep-volume="volume"
            color="yellow"
            @buttonActivated="activate"
            @buttonDeactivated="deactivate"
            :audio-frequency="190"/>
        </div>
      </div>
      <div class="row">
        <div class="col text-right">
          <simon-button
            :id="4"
            :activate="isActive(4)"
            :beep-volume="volume"
            color="green"
            @buttonActivated="activate"
            @buttonDeactivated="deactivate"
            :audio-frequency="150"/>
        </div>
        <div class="col">
          <simon-button
            :id="3"
            :activate="isActive(3)"
            :beep-volume="volume"
            color="blue"
            @buttonActivated="activate"
            @buttonDeactivated="deactivate"
            :audio-frequency="170"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimonButton from './simon-button.vue'
import { setInterval, clearInterval, setTimeout } from 'timers'

export default {
  components: {
    SimonButton
  },
  props: {
    started: {
      type: Boolean,
      required: false,
      default: false
    },
    demoMode: {
      type: Boolean,
      required: false,
      default: false
    },
    volume: {
      type: Number,
      required: false,
      default: 0.1
    }
  },
  data () {
    return {
      isRunning: false,
      sequence: [],
      userSequence: [],
      score: 1,
      indexSequence: 0,
      indexUser: 0,
      currentSequence: 0,
      userSelection: 0,
      gameWidth: 0,
      interval: null,
      soundDuration: 600,
      enabled: false,
      sequenceError: false,
      demoSequence: [1, 2, 3, 4]
    }
  },
  mounted () {
    if (this.demoMode) {
      this.sequence = this.demoSequence
      this.playSequence()
    }
  },
  methods: {
    activate (val) {
      if (this.enabled) {
        this.currentSequence = val
        this.vibrate()
        if (this.sequence[this.indexUser] !== val) {
          this.sequenceError = true
          this.$emit('gameOver', this.score)
        }
      }
    },
    deactivate (val) {
      if (this.enabled && this.currentSequence === val) {
        this.currentSequence = null
        if (this.sequenceError) {
          this.stop()
          this.$emit('gameOver', this.score)
        } else if (this.indexUser + 1 >= this.sequence.length) {
          this.indexUser = 0
          this.score++
          this.$emit('levelChange', this.score)
          this.sequence.push(Math.ceil(Math.random() * 3.99))
          this.playSequence()
          return
        }
        this.indexUser++
      }
    },
    start () {
      this.sequenceError = false
      this.isRunning = true
      this.enabled = false
      this.score = 1
      this.indexUser = 0
      this.sequence = []
      this.sequence.push(Math.ceil(Math.random() * 3.99))
      this.playSequence()
    },
    stop () {
      clearInterval(this.interval)
      this.isRunning = false
      this.currentSequence = 0
      this.indexSequence = 0
      this.enabled = false
    },
    playSequence () {
      this.enabled = false
      this.interval = setInterval(this.nextSequence, this.soundDuration)
    },
    nextSequence () {
      this.currentSequence = this.sequence[this.indexSequence]
      if (this.indexSequence >= this.sequence.length) {
        if (this.demoMode) {
          this.indexSequence = 0
        } else {
          this.stop()
          this.enabled = true
          this.isRunning = true
        }
      } else {
        setTimeout(
          function () {
            this.currentSequence = null
          }.bind(this),
          this.soundDuration * 0.8
        )
        this.indexSequence++
      }
    },
    isActive (value) {
      return this.currentSequence === value
    },
    setGameSize () {
      this.gameWidth = this.$refs('simon-game').innerWidth
    },
    vibrate () {
      // enable vibration support
      navigator.vibrate =
        navigator.vibrate ||
        navigator.webkitVibrate ||
        navigator.mozVibrate ||
        navigator.msVibrate

      if (navigator.vibrate) {
        navigator.vibrate([40])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.simon-game {
  overflow: hidden;
}

h1 {
  color: #fff;
  text-align: center;
}

.text-right {
  text-align: right;
}

.grid {
  width: 100%;
  height: 100%;
  .row {
    width: 100%;
    clear: both;
    .col {
      width: 50%;
      float: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/simon-game/components/simon-game.vue